export const RESET = 'RESET'
export const SET_LOADING = 'SET_LOADING'
export const SET_READY = 'SET_READY'
export const SET_ERROR = 'SET_ERROR'
